angular.module('TetherApp').controller('ParticipantController', [
    '$window',
    '$timeout',
    '$location',
    '$anchorScroll',
    '$mdDialog',
    'conversationModalService',
    'participantService',
    'participantModalService',
    '$mdMedia',
    function (
        $window,
        $timeout,
        $location,
        $anchorScroll,
        $mdDialog,
        conversationModalService,
        participantService,
        participantModalService,
        $mdMedia
    ) {
        let ctrl = this;
        ctrl.participant = {};

        // Search/Filter
        ctrl.isAdvanceSearch = false;
        ctrl.advanceSearch = {};
        ctrl.advanceSearch.opt_in_status = '';
        ctrl.advanceSearch.campaign_list = '';
        ctrl.advanceSearch.experience = '';
        ctrl.participant_count = ' - ';
        ctrl.subscriber_count = ' - ';

        ctrl.toggleAdvanceSearch = function () {
            ctrl.isAdvanceSearch = !ctrl.isAdvanceSearch;
        };

        ctrl.clearSearch = function () {
            ctrl.advanceSearch = {};
            ctrl.advanceSearch.opt_in_status = '';
            ctrl.advanceSearch.campaign_list = '';
            ctrl.advanceSearch.experience = '';
            ctrl.advanceSearch.is_leads = false;
            ctrl.advanceSearch.is_customers = false;
        };

        ctrl.perPageChanged = function () {
            let form = window.document.querySelector('form#query_form');
            if (form) {
                $timeout(function () {
                    form.submit();
                });
            }
        };

        let DialogController = function ($scope, $mdDialog) {
            let dCtrl = this;
            dCtrl.parent = ctrl;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };

            dCtrl.answer = function (answer) {
                $mdDialog.hide(answer);
            };

            let onSend = function (data) {
                // console.log('success');
            };

            let onError = function (data) {
                // console.log('error');
            };

        };

        let onEditParticipant = function () {
            ctrl.callback();
        };

        ctrl.editParticipant = function (participantId, callback) {
            if (participantId != undefined && participantId != '') {
                ctrl.callback = callback;
                participantService.editParticipant(participantId, ctrl.participant)
                    .then(onEditParticipant, onError);
            }
        };

        ctrl.editPopup = function(ev, participantId) {
            participantModalService.getParticipantModal(ev, participantId);
        };

        ctrl.openConversation = function (ev, page, participantId) {
            conversationModalService.getConversationModal(
                ev,
                page,
                participantId
            );
        }

        ctrl.init = function (isAdvance) {
            if (ctrl.advanceSearch.hasOwnProperty('is_leads')
                && (ctrl.advanceSearch.is_leads == 'true'
                    || ctrl.advanceSearch.is_leads == '1')) {
                ctrl.advanceSearch.is_leads = true;
            }
            if (ctrl.advanceSearch.hasOwnProperty('is_customers')
                && (ctrl.advanceSearch.is_customers == 'true'
                    || ctrl.advanceSearch.is_customers == '1')) {
                ctrl.advanceSearch.is_customers = true;
            }
            if (ctrl.advanceSearch.hasOwnProperty('has_notifications')
                && (ctrl.advanceSearch.has_notifications == 'true'
                    || ctrl.advanceSearch.has_notifications == '1')) {
                ctrl.advanceSearch.has_notifications = true;
            }

            participantService
                .getIndexCount(
                    location.search.substr(1)
                )
                .then(onIndexCount, onError);

            let url = new URL(window.location.href);
            let hash = url.searchParams.get("pop");

            if(hash != undefined && hash != '') {
                let event = new Event('click');
                ctrl.editPopup(event, hash);
            }
        };

        let onIndexCount = function (data) {
            ctrl.participant_count = data.participant_count;
            ctrl.subscriber_count = data.subscriber_count;
        }

        let onSummary = function (data) {
            ctrl.summary = data;
        };

        let onError = function (data) {
            // console.log('Error occurred while fetching participant');
        };

        ctrl.delete = function(participantId) {
            if ($window.confirm(self.deleteConfirmationText)) {
                participantService.deleteParticipant(participantId)
                    .then(onDelete, onError);
            }
        };

        let onToggleFlag = function () {
            window.location.reload(true);
        };

        ctrl.toggleFlag = function(clientId, personId) {
            participantService.toggleFlag({
                'client': clientId,
                'person': personId
            }).then(onToggleFlag, onError);
        };

        let onDelete = function (data) {
            $window.location.reload();
        };

        ctrl.isGreaterThanSmall = $mdMedia('gt-sm');
    }
]);
